import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { ButtonOptions } from '../../models/header.model';
@Component({
  selector: 'igx-header',
  imports: [ButtonModule, ButtonGroupModule, NgClass],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  public title = input.required<string>();
  public addPadding = input<boolean>(true);
  public buttonOptions = input<ButtonOptions[]>([]);
  public buttonAlignment = input<'left' | 'center' | 'right'>('right');
}
